import React from 'react';
import { inject, observer } from 'mobx-react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Flex, Box } from 'grid-styled';

import Input from 'components/Input/Input';
import LoginView from 'components/LoginView/LoginView';
import Button from 'components/Button/Button';
import P from 'components/P/P';

import messages from './messages';

const VALID_PASSWORD = 'isValid';
const ERROR_PASSWORD_NOT_EQUAL = 'notEqual';
const ERROR_PASSWORD_EMPTY = 'empty';
const ERROR_PASSWORD_TOO_SHORT = 'tooShort';
const ERROR_PASSWORD_NO_ALPHABETICAL_CHAR = 'noAlphabeticalChar';
const ERROR_PASSWORD_NO_NUMERICAL_CHAR = 'noNumericalChar';

export const isPasswordValid = password => {
  if (password) {
    if (password.length >= 8) {
      if (password.match(/[a-z]/i)) {
        if (password.match(/[0-9]/i)) {
          return VALID_PASSWORD;
        }
        return ERROR_PASSWORD_NO_NUMERICAL_CHAR;
      }
      return ERROR_PASSWORD_NO_ALPHABETICAL_CHAR;
    }
    return ERROR_PASSWORD_TOO_SHORT;
  }
  return ERROR_PASSWORD_EMPTY;
};

@inject('authStore', 'routing')
@observer
class SetPasswordView extends React.Component {
  state = {
    password1: '',
    password2: '',
    password1Error: ERROR_PASSWORD_EMPTY,
    password2Error: ERROR_PASSWORD_EMPTY,
    error: null
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    document.body.classList.add('blue');
  }

  async handleSubmit(event) {
    event.preventDefault();
    const { authStore } = this.props;
    const { password1, password2 } = this.state;
    if (
      isPasswordValid(password1) === VALID_PASSWORD &&
      password1 === password2
    ) {
      this.setState({
        error: null
      });
      const response = await authStore.setPassword(password1);
      if (response.error) {
        this.setState({
          error: response.error.message
        });
      }
    } else {
      this.setState({
        password1Error:
          password1 !== password2
            ? ERROR_PASSWORD_NOT_EQUAL
            : isPasswordValid(password1),
        password2Error:
          password1 !== password2
            ? ERROR_PASSWORD_NOT_EQUAL
            : isPasswordValid(password2),
        error: null
      });
    }
  }

  getMessageForError(error) {
    switch (error) {
      case VALID_PASSWORD:
        return messages.validPassword;
      case ERROR_PASSWORD_EMPTY:
        return messages.errorPasswordEmpty;
      case ERROR_PASSWORD_TOO_SHORT:
        return messages.errorPasswordTooShort;
      case ERROR_PASSWORD_NOT_EQUAL:
        return messages.errorPasswordNotEqual;
      case ERROR_PASSWORD_NO_ALPHABETICAL_CHAR:
        return messages.errorPasswordNoAlphabeticalChar;
      case ERROR_PASSWORD_NO_NUMERICAL_CHAR:
        return messages.errorPasswordNoNumericalChar;
      default:
        return messages.errorSomethingWentWrong;
    }
  }

  updatePassword1(e) {
    const { password2 } = this.state;
    const validState =
      isPasswordValid(password2) === VALID_PASSWORD &&
      password2 === e.target.value;
    this.setState({
      password1: e.target.value,
      password1Error: validState ? VALID_PASSWORD : ERROR_PASSWORD_EMPTY
    });
  }

  onBlur1 = () => {
    const { password1, password2 } = this.state;
    const validState =
      isPasswordValid(password1) === VALID_PASSWORD && password2 === password1;
    if (!validState) {
      this.setState({
        password1Error:
          isPasswordValid(password1) !== VALID_PASSWORD
            ? isPasswordValid(password1)
            : password2 && password1 && password2 !== password1
              ? ERROR_PASSWORD_NOT_EQUAL
              : VALID_PASSWORD
      });
    } else {
      this.setState({
        password1Error: VALID_PASSWORD,
        password2Error: VALID_PASSWORD
      });
    }
  };

  onBlur2 = () => {
    const { password1, password2 } = this.state;
    const validState =
      isPasswordValid(password2) === VALID_PASSWORD && password2 === password1;
    if (!validState) {
      this.setState({
        password2Error:
          isPasswordValid(password2) !== VALID_PASSWORD
            ? isPasswordValid(password2)
            : password2 && password1 && password2 !== password1
              ? ERROR_PASSWORD_NOT_EQUAL
              : VALID_PASSWORD
      });
    } else {
      this.setState({
        password1Error: VALID_PASSWORD,
        password2Error: VALID_PASSWORD
      });
    }
  };

  updatePassword2(e) {
    const { password1 } = this.state;
    const validState =
      isPasswordValid(password1) === VALID_PASSWORD &&
      password1 === e.target.value;
    this.setState({
      password2: e.target.value,
      password2Error: validState ? VALID_PASSWORD : ERROR_PASSWORD_EMPTY
    });
  }

  render() {
    const {
      password1,
      password2,
      password1Error,
      password2Error,
      error
    } = this.state;
    const { intl: { formatMessage } } = this.props;
    const title = formatMessage(messages.loginTitle);
    const message = formatMessage(messages.setPasswordMessage);

    const border1 =
      password1Error === VALID_PASSWORD
        ? false
        : ERROR_PASSWORD_EMPTY === password1Error ? false : true;
    const border2 =
      password2Error === VALID_PASSWORD
        ? false
        : ERROR_PASSWORD_EMPTY === password2Error ? false : true;

    return (
      <LoginView title={title} message={message}>
        <form onSubmit={e => this.handleSubmit(e)}>
          {error && (
            <Box mb={10}>
              <P danger>{error}</P>
            </Box>
          )}
          <Box mb={3}>
            <Input
              onBlur={this.onBlur1}
              placeholder={formatMessage(messages.loginPassword)}
              onChange={e => this.updatePassword1(e)}
              value={password1}
              type="password"
              error={border1}
            />
          </Box>
          {password1Error !== VALID_PASSWORD &&
            password1Error !== ERROR_PASSWORD_EMPTY &&
            password1Error !== ERROR_PASSWORD_NOT_EQUAL && (
              <Box mb={10}>
                <P danger>
                  {formatMessage(this.getMessageForError(password1Error))}
                </P>
              </Box>
            )}
          <Box mb={3}>
            <Input
              onBlur={this.onBlur2}
              onChange={e => this.updatePassword2(e)}
              placeholder={formatMessage(messages.loginPasswordRepeat)}
              value={password2}
              type="password"
              error={border2}
            />
          </Box>
          {password2Error !== VALID_PASSWORD &&
            password2Error !== ERROR_PASSWORD_EMPTY &&
            password2Error !== ERROR_PASSWORD_NOT_EQUAL && (
              <Box mb={10}>
                <P danger>
                  {formatMessage(this.getMessageForError(password2Error))}
                </P>
              </Box>
            )}
          {(password1Error === ERROR_PASSWORD_NOT_EQUAL ||
            password2Error === ERROR_PASSWORD_NOT_EQUAL) && (
            <Box mb={10}>
              <P danger>
                <FormattedMessage {...messages.errorPasswordNotEqual} />{' '}
              </P>
            </Box>
          )}
          <Flex flexWrap="wrap">
            <Box width={[1, 1, 1 / 2]} mb={[3, 3, 0]}>
              <Button
                disabled={!password1 || !password2 || password1 !== password2}
                secondary
              >
                <FormattedMessage {...messages.setPasswordSubmitButton} />
              </Button>
            </Box>
          </Flex>
        </form>
      </LoginView>
    );
  }
}

export default injectIntl(SetPasswordView);



// WEBPACK FOOTER //
// ./src/containers/login/SetPasswordView.js